module.exports = __webpack_public_path__ + "media/images/job1_icon-7f23b5044236fd2ea34daa5124806a6f.png";